import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useIntl } from "react-intl";
import {
  SkuContentRule,
  SkuContentRuleRequestExtended,
  ISkuContentRuleRequest,
  Skus,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import SkuRuleForm from "./SkuRuleForm";

type SkuRuleUpdateFormProps = {
  skuRule: SkuContentRule;
  onSkuRuleUpdated: () => void;
  onCancel: () => void;
  sku: Skus;
  isMembershipGatedAccessEnabled: boolean;
};

const SkuRuleUpdateForm = ({
  skuRule,
  onSkuRuleUpdated,
  onCancel,
  sku,
  isMembershipGatedAccessEnabled,
}: SkuRuleUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const onSubmit = async (values: ISkuContentRuleRequest) => {
    if (!sku.ownerOrganizationId) {
      return { [FORM_ERROR]: t({ id: "genericError" }) };
    }
    try {
      await registerPromise(
        skuService.saveSkuContentRule(
          sku.id!,
          new SkuContentRuleRequestExtended({ ...values, organizationId: sku.ownerOrganizationId })
        )
      );
      onSkuRuleUpdated();
    } catch (err) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <SkuRuleForm
      skuRule={skuRule}
      onCancel={onCancel}
      onSubmit={onSubmit}
      sku={sku}
      isMembershipGatedAccessEnabled={isMembershipGatedAccessEnabled}
      isEdit={true}
      title={t({ id: "updateRuleTitle" })}
      submitLabel={t({ id: "updateRuleButton" })}
    />
  );
};

export default SkuRuleUpdateForm;
